import React, {useState} from 'react';
import styles from './FAQSection.module.css';
import icMinus from "../assets/icon/ic_minus.svg";
import icPlus from "../assets/icon/ic_plus.svg";
import "react-modal-video/css/modal-video.min.css";
import {FAQItem} from "./FAQSection";
import {useTranslation, Trans} from "react-i18next";

const FAQCard: React.FC<FAQItem> = ({question, answer}) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);

    return (
        <div className={styles.faqItem}>
            <button
                className={styles.faqQuestion}
                onClick={() => setIsExpanded(!isExpanded)}
                aria-expanded={isExpanded}>
                {question}
                <img
                    src={isExpanded ? icMinus :  icPlus}
                    alt=""
                    className={styles.icon}
                />
            </button>
            {isExpanded && (
                <div className={styles.faqAnswer}>
                    <span>
                        <Trans i18nKey={answer}
                               />
                    </span>
                    {/*{answer.split('\n').map(line => <div>{line}</div>)}*/}
                </div>
            )}
        </div>
    );
};

export default FAQCard;